<page-title text="{{data?.title}} | BitOasis" i18n-text="@@pageTitle.page"></page-title>

<page-meta
    description=""
    i18n-description="@@pageMeta.description.vip">
</page-meta>

<ng-container *ngIf="{isMobileWebView : isMobileWebView$ | async} as vm">
  <site-layout class="push" [hideHeader]="vm.isMobileWebView">
    <loading *ngIf="loading" class="full">
      <ng-container i18n="@@front.page.loading">Loading page details</ng-container>
    </loading>

    <div *ngIf="data">
        <h2 class="text-header text-bold text-center mb-2" [innerHTML]="data?.title"></h2>
        <div class="p-3"></div>

        <div class="blog-content" [innerHTML]="data?.content"></div>
        <div class="p-3"></div>
    </div>
  </site-layout>
  <site-footer *ngIf="!vm.isMobileWebView"></site-footer>
</ng-container>
